import React, { forwardRef } from 'react';
import { Checkbox, Label } from '../';

import './CheckboxList.css';

const _CheckboxList = (
  {
    name,
    onChange,
    value = [],
    options = [],
    label,
    disabled = false,
    className,
    title,
    showSelectAll = false,
  },
  ref
) => {
  const fullySelected = value.filter(x => !x.partial);
  const allIsSelected = fullySelected.length === options.length;

  const handleSelectAll = () => {
    if (allIsSelected) {
      options.forEach(opt => onChange({ name, value: opt.value }));
    } else {
      options
        .filter(opt => !value.find(x => x.value === opt.value && !x.partial))
        .forEach(opt => onChange({ name, value: opt.value }));
    }
  };

  const handleChange = event => {
    const optionValue = event.target.name.replace('object_', '');
    onChange({ name, value: optionValue });
  };

  return (
    <div
      className={
        'CheckboxList' + (className ? ' ' + className : '') + (disabled ? ' disabled' : '')
      }
    >
      <Label label={label} htmlFor={name} title={title} disabled={disabled} />

      <div className="checkbox-list-options">
        {showSelectAll && (
          <Checkbox
            checked={allIsSelected}
            name="select_all"
            label="(All)"
            className="select-all"
            onChange={handleSelectAll}
            disabled={disabled}
          />
        )}
        {options.map((option, index) => {
          const found = value.find(x => x.value === option.value);
          const checkedState = found ? (found.partial ? 'multiple' : true) : false;

          return (
            <Checkbox
              key={index}
              checked={checkedState}
              name={`object_${option.value}`}
              label={option.label}
              title={option.tooltip}
              onChange={handleChange}
              disabled={disabled}
            />
          );
        })}
      </div>
    </div>
  );
};

export const CheckboxList = forwardRef(_CheckboxList);
